import { render, staticRenderFns } from "./ContractHeader.vue?vue&type=template&id=2b5b61ed&scoped=true&"
import script from "./ContractHeader.vue?vue&type=script&lang=js&"
export * from "./ContractHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContractHeader.vue?vue&type=style&index=0&id=2b5b61ed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b61ed",
  null
  
)

export default component.exports